/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import type { LegacyRef, MutableRefObject, RefCallback } from "react";

export function mergeRefs<T = any>(refs: Array<MutableRefObject<T> | LegacyRef<T>>): RefCallback<T> {
	return (value) => {
		refs.forEach((ref) => {
			if (typeof ref === "function") {
				ref(value);
			} else if (ref != null) {
				(ref as MutableRefObject<T | null>).current = value;
			}
		});
	};
}

export function useMergedRefs<T>(...refs: (React.Ref<T> | undefined)[]): React.RefCallback<T> {
	return (value) => {
		for (const ref of refs) {
			if (typeof ref === "function") {
				ref(value);
			} else if (ref && typeof ref === "object") {
				(ref as React.MutableRefObject<T | null>).current = value;
			}
		}
	};
}
